<div class="main-container" *ngIf="!isLoading" data-cy="ar-payment-plan-create">

  <button mat-button class="cancel-button" (click)="close(false)" data-cy="ar-payment-plan-create-close-btn"><i class="material-icons">close</i></button>

  <div class="header" data-cy="ar-payment-plan-create-header">
    {{ mode === 'create' ? 'Create' : (mode === 'edit' ? 'Edit' : 'Merge') }} Payment Plan
  </div>

  <div class="ledger-item-list mat-elevation-z2" data-cy="ar-payment-plan-create-ledger-items">

    <div class="table-container" data-cy="ar-payment-plan-create-table-container">
      <table mat-table [dataSource]="ledgerItems" class="ledger-table" data-cy="ar-payment-plan-create-ledger-table">

        <ng-container matColumnDef="procedure">
          <th mat-header-cell *matHeaderCellDef data-cy="ar-payment-plan-create-procedure-header"> Procedure </th>
          <td mat-cell *matCellDef="let element" data-cy="ar-payment-plan-create-procedure-cell"> {{element.dataARTransactionItem.dataPatientCaseWorkItem.cfgCaseProcedure.ProcedureName}} </td>
        </ng-container>

        <ng-container matColumnDef="code">
          <th mat-header-cell *matHeaderCellDef data-cy="ar-payment-plan-create-code-header"> Code </th>
          <td mat-cell *matCellDef="let element" data-cy="ar-payment-plan-create-code-cell"> {{ element.dataARTransactionItem ? element.dataARTransactionItem.Code : '-' }} </td>
        </ng-container>

        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef data-cy="ar-payment-plan-create-amount-header"> Amount </th>
          <td mat-cell *matCellDef="let element" data-cy="ar-payment-plan-create-amount-cell">  {{ calcAdjustedPrice(element) | currency }} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="ledgerItemColumns" data-cy="ar-payment-plan-create-header-row"></tr>
        <tr mat-row *matRowDef="let row; columns: ledgerItemColumns;" data-cy="ar-payment-plan-create-data-row"></tr>
      </table>

    </div>

    <div class="ledger-total-container" data-cy="ar-payment-plan-create-ledger-total">
      Total: {{ paymentPlan.TotalAmount | currency}}
    </div>

  </div>

  <div class="plan-detail mat-elevation-z2" data-cy="ar-payment-plan-create-plan-detail">

    <div class="plan-header" data-cy="ar-payment-plan-create-plan-description">
      {{ paymentPlan.Description }}
    </div>

    <div class="plan-left-container" data-cy="ar-payment-plan-create-plan-left">

      <div class="plan-item-list" data-cy="ar-payment-plan-create-plan-items">
        <table mat-table [dataSource]="paymentPlan.dataARPaymentPlanItems" class="plan-item-table" data-cy="ar-payment-plan-create-plan-table">

          <ng-container matColumnDef="number">
            <th mat-header-cell *matHeaderCellDef data-cy="ar-payment-plan-create-number-header"> # </th>
            <td mat-cell *matCellDef="let element; let i = index" data-cy="ar-payment-plan-create-number-cell"> {{i+1}} </td>
          </ng-container>

          <ng-container matColumnDef="due">
            <th mat-header-cell *matHeaderCellDef data-cy="ar-payment-plan-create-due-header"> Due </th>
            <td mat-cell *matCellDef="let element; let i = index" data-cy="ar-payment-plan-create-due-cell">
              <mat-form-field class="payment-date-picker" data-cy="ar-payment-plan-create-due-date-field">
                <input matInput
                       [disabled]="element.enumPaymentPlanItemStatusID === enumPaymentPlanStatusPaidItem"
                       [matDatepicker]="i"
                       [min]="minDate"
                       [(ngModel)]="element.DueDate"
                       (ngModelChange)="onSinglePaymentDateChanged(paymentPlan)"
                       data-cy="ar-payment-plan-create-due-date-input">
                <mat-datepicker-toggle matSuffix [for]="i" data-cy="ar-payment-plan-create-due-date-toggle"></mat-datepicker-toggle>
                <mat-datepicker #i data-cy="ar-payment-plan-create-due-date-picker"></mat-datepicker>
              </mat-form-field>
            </td>
          </ng-container>

          <ng-container matColumnDef="amount">
            <th mat-header-cell *matHeaderCellDef data-cy="ar-payment-plan-create-plan-amount-header"> Amount </th>
            <td mat-cell *matCellDef="let element" data-cy="ar-payment-plan-create-plan-amount-cell">
              <mat-form-field class="payment-amount-inputt" data-cy="ar-payment-plan-create-plan-amount-field">
                <input matInput type="number" min="0" step="0.01" [(ngModel)]="element.Amount" [disabled]="element.enumPaymentPlanItemStatusID === enumPaymentPlanStatusPaidItem" data-cy="ar-payment-plan-create-plan-amount-input">
              </mat-form-field>
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef data-cy="ar-payment-plan-create-status-header"> Status </th>
            <td mat-cell *matCellDef="let element" data-cy="ar-payment-plan-create-status-cell"> {{ getStatusOfPlanItem(element) }} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="planItemColumns" data-cy="ar-payment-plan-create-plan-header-row"></tr>
          <tr mat-row *matRowDef="let row; columns: planItemColumns;" data-cy="ar-payment-plan-create-plan-data-row"></tr>
        </table>

      </div>

    </div>

    <div class="plan-right-container" data-cy="ar-payment-plan-create-plan-right">

      <div data-cy="ar-payment-plan-create-payments-container">
        <mat-form-field class="payments-input" data-cy="ar-payment-plan-create-payments-field">
          <mat-label data-cy="ar-payment-plan-create-payments-label">Payments</mat-label>
          <input [disabled]="paymentPlan.enumPaymentPlanStatusID === enumPaymentPlanStatusPaid" matInput type="number" min="1" [(ngModel)]="numberOfPayments" (ngModelChange)="initPlanItems(paymentPlan,numberOfPayments)" data-cy="ar-payment-plan-create-payments-input">
        </mat-form-field>        
      </div>

      <div data-cy="ar-payment-plan-create-first-payment-container">
        <mat-form-field data-cy="ar-payment-plan-create-first-payment-field">
          <mat-label data-cy="ar-payment-plan-create-first-payment-label">First Payment Date</mat-label>
          <input matInput [disabled]="paymentPlan.enumPaymentPlanStatusID === enumPaymentPlanStatusPaid" [matDatepicker]="picker" [(ngModel)]="firstPaymentDate" (ngModelChange)="initPlanItems(paymentPlan,numberOfPayments)" data-cy="ar-payment-plan-create-first-payment-input">
          <mat-datepicker-toggle matSuffix [for]="picker" data-cy="ar-payment-plan-create-first-payment-toggle"></mat-datepicker-toggle>
          <mat-datepicker #picker data-cy="ar-payment-plan-create-first-payment-picker"></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="patient-options" data-cy="ar-payment-plan-create-patient-options">
        <mat-checkbox class="patient-accepted-checkbox" [disabled]="true" [(ngModel)]="paymentPlan.AcceptedDate" data-cy="ar-payment-plan-create-patient-accepted-checkbox">Patient Accepted</mat-checkbox>
        <mat-form-field data-cy="ar-payment-plan-create-accepted-date-field">
          <mat-label data-cy="ar-payment-plan-create-accepted-date-label">Accepted Date</mat-label>
          <!--[disabled]="!paymentPlan.AcceptedDate"-->
          <input matInput
                 [disabled]="true"
                 [matDatepicker]="patientAcceptedPicker"
                 [(ngModel)]="paymentPlan.isPatientAccepted"
                 data-cy="ar-payment-plan-create-accepted-date-input">
          <mat-datepicker-toggle matSuffix [for]="patientAcceptedPicker" data-cy="ar-payment-plan-create-accepted-date-toggle"></mat-datepicker-toggle>
          <mat-datepicker #patientAcceptedPicker data-cy="ar-payment-plan-create-accepted-date-picker"></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="summary-container" data-cy="ar-payment-plan-create-summary-container">

        <div class="summary-header" data-cy="ar-payment-plan-create-summary-header">
          Summary
        </div>

        <div data-cy="ar-payment-plan-create-summary-total">
          Total: {{ (calcTotalForPlanItems(paymentPlan) + downPaymentAmount) | currency }}
        </div>

        <div data-cy="ar-payment-plan-create-description-container">
          <mat-form-field class="description-input" data-cy="ar-payment-plan-create-description-field">
            <mat-label data-cy="ar-payment-plan-create-description-label">Description</mat-label>
            <input matInput
                   [disabled]="paymentPlan.enumPaymentPlanStatusID === enumPaymentPlanStatusPaid"
                   [(ngModel)]="paymentPlan.Description"
                   data-cy="ar-payment-plan-create-description-input">
          </mat-form-field>
        </div>

      </div>

    </div>

  </div>

  <div class="action-container" data-cy="ar-payment-plan-create-action-container">

    <div class="action-left-container" data-cy="ar-payment-plan-create-action-left">
      <!--<button class="action-button" mat-raised-button (click)="clearPaymentPlan()" color="primary">Clear</button>-->
    </div>

    <div class="action-right-container" data-cy="ar-payment-plan-create-action-right">
      <button class="action-button" mat-button color="warn" (click)="close(false)" data-cy="ar-payment-plan-create-cancel-btn">Cancel</button>
      <button class="action-button" mat-raised-button color="primary" [disabled]="!checkIfValid()" (click)="savePaymentPlan()" data-cy="ar-payment-plan-create-save-btn">Done</button>
    </div>

  </div>

</div>
<div class="spinner-container" *ngIf="isLoading" data-cy="ar-payment-plan-create-spinner-container">
  <mat-spinner data-cy="ar-payment-plan-create-spinner"></mat-spinner>
</div>
